/**
 * Sorted list of filters by SEO hits only (organic).
 * If more than one filter is used on SERP, then we should use the rSLP canonical link for the highest ranked filterid out of those specified
 */
const orderedFiltersBySEOhits = [
    'filter:64',
    'filter:74',
    'filter:32',
    'filter:92',
    'filter:27',
    'filter:91',
    'filter:69',
    'filter:23',
    'filter:24',
    'filter:30',
    'filter:42',
    'filter:83',
    'filter:35',
    'filter:63',
    'filter:44',
    'filter:39',
    'filter:75',
    'filter:79',
    'filter:43',
    'filter:78',
    'filter:66',
    'filter:36',
    'filter:80',
    'filter:82',
    'filter:71',
    'filter:12',
    'filter:72',
    'filter:76',
    'filter:10',
    'filter:61',
    'filter:1008',
    'filter:67',
    'filter:87',
    'filter:84',
    'filter:60',
    'filter:73',
    'filter:38',
    'filter:77',
    'filter:55',
    'filter:65',
    'filter:37',
    'filter:81',
    'filter:62',
    'filter:41',
    'filter:70',
    'filter:33',
];

module.exports = {
    orderedFiltersBySEOhits,
};
